import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

export const SIAT_CORE = [
  CommonModule,
  ReactiveFormsModule,
  FormsModule,
  TranslatePipe,
];
